import React from "react"
import Map from "../shared/about/Map"

const parameters = 'pb=!1m18!1m12!1m3!1d3221.500464828373!2d139.40257979999998!3d36.1543744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601f294561449f4f%3A0x8c6cf2ffda77e046!2z5YWQ56ul55m66YGU5pSv5o-044O75pS-6Kqy5b6M562J44OH44Kk44K144O844OT44K5IOOBmeOBpuOBgg!5e0!3m2!1sja!2sjp!4v1747273900871!5m2!1sja!2sjp" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>'

const AboutMap = () => {
  return <Map parameters={ parameters } />
}

export default AboutMap
